// Конфигурация для каждого варианта иконки
export const iconConfig = {
	metro: {
		iconPath: 'metro',
		ariaLabel: 'Метро',
	},
	telegram_gray: {
		iconPath: 'telegram-gray',
		ariaLabel: 'Telegram',
	},
	vk_gray: {
		iconPath: 'vk-gray',
		ariaLabel: 'ВК',
	},
	filter_list: {
		iconPath: 'fa-filter-list',
		ariaLabel: 'Фильтр',
	},
	edit: {
		iconPath: 'icon-edit',
		ariaLabel: 'Редактировать',
	},
	add: {
		iconPath: 'icon-add',
		ariaLabel: 'Добавить',
	},
}
